import React, { useState } from 'react';

import { Dialog, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { studentTagAssignmentsPublish } from 'sdk';

import { notifyError, notifySuccess } from 'utils/notifications';

import styles from './style.module.scss';

const StudentBulkPublishDialog = ({
  studentsToPublish = [],
  studentsNeedsReview = [],
  onClose,
  onPublish,
  onActionSuccess
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handlePublishing = async () => {
    setIsSubmitting(true);
    onPublish();

    const publishableIds = studentsToPublish.map(
      (student) => student.student_tag_assignment_id
    );

    const { success } = await studentTagAssignmentsPublish({
      data: { student_tag_assignment_ids: publishableIds }
    });

    if (success) {
      notifySuccess(`${studentsToPublish.length} student works published!`);
      onActionSuccess();
      onClose();
    } else {
      notifyError('Failed to publish works. Please try again.');
    }
  };

  return (
    <Dialog
      open
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ style: { borderRadius: 12 } }}
    >
      <div className={styles.dialogContainer}>
        <header className={styles.header}>
          <h2>Bulk Publish Work</h2>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </header>

        <section className={styles.section}>
          <span className={styles.sectionTitle}>
            Ready to Publish ({studentsToPublish.length})
          </span>
          <div className={styles.studentList}>
            {studentsToPublish.map((student) => (
              <div key={student.student_id} className={styles.studentRow}>
                <span>{student.student_name}</span>
              </div>
            ))}
          </div>
        </section>

        {studentsNeedsReview.length > 0 && (
          <section className={styles.section}>
            <span className={styles.sectionTitle}>
              Will Not Be Published ({studentsNeedsReview.length})
            </span>
            <span className={styles.sectionWarning}>
              Currently pending Review or loading
            </span>
            <div className={`${styles.studentList} ${styles.excluded}`}>
              {studentsNeedsReview.map((student) => (
                <div key={student.student_id} className={styles.studentRow}>
                  <span>{student.student_name}</span>
                </div>
              ))}
            </div>
          </section>
        )}

        <div className={styles.actions}>
          <button
            className={styles.publishBtn}
            onClick={handlePublishing}
            disabled={isSubmitting || studentsToPublish.length === 0}
          >
            {isSubmitting
              ? 'Publishing...'
              : `Publish ${studentsToPublish.length} Items`}
          </button>

          <button className={styles.cancelLink} onClick={onClose}>
            Cancel and go back
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default StudentBulkPublishDialog;
